import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { Link, useNavigate } from "react-router-dom";
import "../styles/global.css";

const DashboardBase = ({ 
  children, 
  title = "Dashboard", 
  userRole = "Admin",
  userName = "Usuario",
  navigationItems = [],
  activeNav = "dashboard"
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const defaultNavItems = [
    { id: "dashboard", label: "Dashboard", icon: "📊", path: "/" },
    { id: "empresas", label: "Empresas", icon: "🏢", path: "/empresas" },
    { id: "usuarios", label: "Usuarios", icon: "👥", path: "/usuarios" },
    { id: "empleados", label: "Empleados", icon: "👤", path: "/empleados" },
    { id: "evaluaciones", label: "Evaluaciones", icon: "📝", path: "/evaluaciones" },
    { id: "reportes", label: "Reportes", icon: "📈", path: "/reportes" },
    { id: "rrhh", label: "RRHH", icon: "🧑‍💼", path: "/rrhh" },
    { id: "psicologo", label: "Psicólogo", icon: "🧠", path: "/psicologo" },
    { id: "configuracion", label: "Configuración", icon: "⚙️", path: "/configuracion" }
  ];

  const navItems = navigationItems.length > 0 ? navigationItems : defaultNavItems;

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <div className={`sidebar ${!sidebarOpen ? 'collapsed' : ''}`}>
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{ color: '#3b82f6', fontSize: '1.5em', fontWeight: '700' }}>
            Elipse 360°
          </h2>
          <p style={{ color: '#64748b', fontSize: '0.9em', marginTop: '4px' }}>
            Evaluación de Desempeño
          </p>
        </div>

        <nav>
          {navItems.map((item) => (
            <Link
              key={item.id}
              to={item.path || `/${item.id}`}
              className={`nav-item ${activeNav === item.id ? 'active' : ''}`}
              style={{ textDecoration: 'none' }}
            >
              <span style={{ marginRight: '12px' }}>{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </nav>

        <div style={{ marginTop: 'auto', paddingTop: '32px' }}>
          <div style={{ 
            padding: '12px', 
            background: 'rgba(59, 130, 246, 0.1)', 
            borderRadius: '6px',
            marginBottom: '16px'
          }}>
            <div style={{ fontSize: '0.9em', fontWeight: '600' }}>
              {userName}
            </div>
            <div style={{ fontSize: '0.8em', color: '#64748b' }}>
              {userRole}
            </div>
          </div>
          <button 
            onClick={handleLogout}
            className="btn btn-secondary"
            style={{ width: '100%' }}
          >
            Cerrar Sesión
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        <header className="header">
          <div className="flex items-center justify-between" style={{ width: '100%' }}>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '1.2em',
                  cursor: 'pointer',
                  marginRight: '16px'
                }}
              >
                ☰
              </button>
              <h1 style={{ fontSize: '1.5em', fontWeight: '600' }}>
                {title}
              </h1>
            </div>
            <div style={{ fontSize: '0.9em' }}>
              {new Date().toLocaleDateString('es-ES', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </div>
          </div>
        </header>

        {/* Content Area */}
        <div className="content-area">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardBase;
